import { render, staticRenderFns } from "./SharedProjects.vue?vue&type=template&id=53054228&scoped=true&"
import script from "./SharedProjects.vue?vue&type=script&lang=js&"
export * from "./SharedProjects.vue?vue&type=script&lang=js&"
import style0 from "./SharedProjects.vue?vue&type=style&index=0&id=53054228&prod&lang=scss&scoped=true&"
import style1 from "./SharedProjects.vue?vue&type=style&index=1&id=53054228&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53054228",
  null
  
)

export default component.exports